import { render, staticRenderFns } from "./FaceId.vue?vue&type=template&id=587c22da"
import script from "./FaceId.vue?vue&type=script&lang=js"
export * from "./FaceId.vue?vue&type=script&lang=js"
import style0 from "./FaceId.vue?vue&type=style&index=0&id=587c22da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports